export const otkaz_ugovora_nezadovoljenje_na_probnom_radu = {
  templateId: 15,
  category: 1,
  templateTitle: "Odluka o otkazu ugovora zbog nezadovoljenja na probnom radu",
  templateDescription: `Otkaz zbog nezadovoljavanja na probnom roku specifična je vrsta redovitog otkaza na koji se ne primjenjuju odredba Zakona o radu, inače primjenjiva kod preostalih vrsta redovitih otkaza, nego je u bitnome za ovu vrstu otkaza određeno Zakonom da je otkazni rok najmanje 7 dana i da nema zastoja tijeka otkaznog roka zbog privremene nesposobnosti za rad te sličnih okolnosti, a koje bi inače predstavljale razlog za zastoj otkaznog roka kod drugih vrsta redovitih otkaza.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Nezadovoljavanje radnika na probnom radu predstavlja posebno opravdan razlog za redoviti otkaz ugovora o radu. </p>
    <p>Na ovu specifičnu vrstu otkaza (otkaz zbog nezadovoljavanja na probnom radu) ne primjenjuju se sve zakonske odredbe koje se primjenjuju kod drugih vrsta otkaza. Npr. kod ove vrste otkaza trajanje otkaznog roka je puno kraće, otkazni rok neprekidno teče i za vrijeme privremene nesposobnosti za rad i sl., točnije, primjenjuju se samo sljedeće odredbe: </p>
    <p>- otkazni rok kod ugovorenog probnog rada je najmanje sedam dana te počinje teći od dostave, </p>
    <p>- otkaz mora biti u pisanom obliku, obrazložen te dostavljen osobi kojoj se otkazuje, </p>
    <p>- kod tijeka trajanja otkaznog roka nema zastoja (npr. zbog privremene nesposobnosti za rad i sl.). </p>
    <p>Također, Zakon o radu ne sadrži nikakve odredbe o tome na koji način bi se utvrđivali rezultati odnosno nezadovoljavanje na probnom radu, stoga je navedeno prepušteno odluci poslodavca odnosno poslodavac navedeno može regulirati pravilnikom odnosno drugim internim aktom.</p>
    <p>Zakonski je moguće ugovoriti probni rad i kod sklapanja ugovora o radu na određeno vrijeme.  </p>
    <p>Inače, najduže vrijeme probnog rada je zakonski ograničeno te ne smije trajati duže od šest mjeseci. </p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong> - Nedopušteni razlozi za otkaz ugovora o radu</strong></p>
    <p>Pojašnjenje: ako sud utvrdi da otkaz poslodavca nije dopušten i da radni odnos nije prestao, naložiti će vraćanje radnika na posao, a radnik će imati i pravo na naknadu plaće umanjenu za iznos plaće koju je kroz to vrijeme primao. Radnik koji osporava dopuštenost otkaza može tražiti da sud privremeno, do okončanja spora, naloži njegov povratak na posao. </p>
    <p><strong> - Tumačenje da otkaz ne može biti uručen za vrijeme trudnoće, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada s polovicom punog radnog vremena radi pojačane brige i njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju, odnosno u roku od petnaest dana od prestanka trudnoće ili prestanka korištenja tih prava, poslodavac ne smije otkazati ugovor o radu trudnici i osobi koja se koristi nekim od tih prava. </strong></p>
    <p>Pojašnjenje: otkaz može biti uručen, no otkazni rokovi počinju teći tek po isteku spomenutih okolnosti pa time radni odnos ne može niti prestati sve dok traju spomenute okolnosti.</p>
    <p><strong>- Netočno određivanje  trajanja i računanje tijeka otkaznog roka</strong></p>
    <p>Pojašnjenje: netočno računanje i određivanje tijeka otkaznog roka može dovesti do gubitka određenih prava radnika, a time i pokretanja sudskih postupaka radi ostvarenja istih. </p>
    <p><strong> - Dostava otkaza nije izvršena u skladu sa Zakonom</strong></p>
    <p>Pojašnjenje: u slučaju dostave koja nije obavljena zakonito, smatra se da otkaz nije niti uručen, a time ne mogu niti nastupiti posljedice otkaza. </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu. </p>
  `,

  sides: [
    {
      prefix: "Na temelju Zakona o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: "donosi sljedeću",
  title: "ODLUKU O OTKAZU UGOVORA O RADU",

  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: 'text', content: 'Radniku' },
            { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
            { type: "text", content: "," },
            { type: 'text', content: 'iz',},
            { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
            { type: 'text', content: ',' },
            { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
            { type: 'text', content: 'otkazuje se ugovor o radu na' },
            { type: "input",  required: true, placeholder: "određeno/neodređeno"},
            { type: 'text', content: 'vrijeme, sklopljen dana'},
            { type: 'input', value: '', required: true },
            { type: 'text', content: 'godine,' },
            { type: "text", content: "radi nezadovoljavanja na probnom radu. " }
          ]
        }]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Poslodavac otkazuje ugovor o radu iz prethodnog stavka zbog neuspjeha Radnika na probnom radu."
        }]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: 'Radniku prestaje radni odnos uz otkazni rok u trajanju određenom ovom Odlukom.'
        }]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radniku prestaje radni odnos istekom otkaznog roka od sedam dana, a koji počinje teći od dana dostave ove odluke Radniku."
        }]
    },
    {
      title: "",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Za vrijeme otkaznog roka, Radnik se oslobađa obveze rada.",
            "Za vrijeme otkaznog roka, Radnik se ne oslobađa obveze rada.",
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        },
      ]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radnik nema pravo na otpremninu.",
        },
      ]
    },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Po ocjeni poslodavca, Radnik nije zadovoljio na probnom radu."
        }]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Slijedom toga, a sukladno Zakonu o radu odlučeno je kako je navedeno u ovoj Odluci.\r\nTrajanje i tijek otkaznog roka iz ove Odluke utvrđeni su sukladno čl. 53. i 121. Zakona o radu.\r\nPravo Radnika na otpremninu iz ove Odluke utvrđeno je na temelju čl. 126. Zakona o radu.\r\nSlijedom iznesenog, donesena je ova Odluka."
        }]
    },
    {
      title: "NAPUTAK O ZAŠTITI PRAVA",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke."
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
    {
      static: true,
      mandatory: true,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
          content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
        },
      ]
    },
  ],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/15_otkaz_ugovora_nezadovoljenje_na_probnom_radu.ts